import cookies from 'react-cookies';
import withCallApi from '../utils/withCallApi';
import Home from './Home';

const HomePage = () => {
  switch (cookies.load('langCd')) {
    case 'ar':
      // set direction to rtl
      document.body.dir = 'rtl';
      break;

    case 'ru':
    case 'tr':
    case 'tl':
      // set direction to ltr
      document.body.dir = 'ltr';
      break;

    default:
      // Do nothing
      break;
  }

  return withCallApi(Home, null, {}, true);
};

HomePage.propTypes = {
};

export default HomePage;
